/**
 * @generated SignedSource<<7cb5edba987df2a093699e8e18f3c4e7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawer_waitingRoomAppointment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerData_WaitingRoomAppointment" | "appointmentDrawerPatient_WaitingRoomAppointment">;
  readonly " $fragmentType": "appointmentDrawer_waitingRoomAppointment";
};
export type appointmentDrawer_waitingRoomAppointment$key = {
  readonly " $data"?: appointmentDrawer_waitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawer_waitingRoomAppointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawer_waitingRoomAppointment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentDrawerPatient_WaitingRoomAppointment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "appointmentDrawerData_WaitingRoomAppointment"
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};

(node as any).hash = "6c75311935bf89fa65821146c195c08f";

export default node;
